import { render, staticRenderFns } from "./EmployeeLeavesStatusCard.vue?vue&type=template&id=b1f9128a"
import script from "./EmployeeLeavesStatusCard.vue?vue&type=script&lang=js"
export * from "./EmployeeLeavesStatusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports